export default "__VITE_ASSET__DnM21qob__ 640w, __VITE_ASSET__Cz4MbMYs__ 1024w, __VITE_ASSET__B837gezA__ 1920w";